<template>
  <div class="search">
    <!-- Input -->
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Search..."  v-model.trim="searchTerm" size="50">
    </div>

    <!-- Results -->
    <div class="dropdown-menu results" v-if="searchTerm || isSearching">

      <!-- Loading -->
      <div class="dropdown-item" v-if="isSearching">
        <img src="static/img/loading.gif" height="32"/>
      </div>

      <!-- No Results -->
      <span v-if="!haveResults && !isSearching">
        <div class="dropdown-item disabled">Sorry, no results where found...</div>
      </span>

      <!-- Results -->
      <div v-if="haveResults && !isSearching">

        <!-- Devices -->
        <div v-if="devices.length > 0">
          <h6 class="dropdown-header"><i class="icon-screen-smartphone"></i> Devices</h6>
          <router-link class="dropdown-item" :to="{ name: 'Device', params: {id: device.id}}" v-for="device in devices" :key="device.id" @click.native="closeSearch()">
            <span v-html="formatMatch(device.identifier)"></span> <br/>
            <div class="small text-muted">{{device.uid}}</div>
          </router-link>
        </div>

        <!-- Files -->
        <div v-if="files.length > 0">
          <h6 class="dropdown-header"><i class="icon-docs"></i> Files</h6>
          <router-link class="dropdown-item" :to="{ name: 'File', params: {id: encodeCanonicalURL(file)}}" v-for="file in files" :key="file.canonical_url" @click.native="closeSearch()">
            <span v-html="formatMatch(file.canonical_url)"></span> <br/>
            <div class="small text-muted">{{file.updated_at | moment('LLL')}}</div>
          </router-link>
        </div>

      </div>

      <!-- Close -->
      <h6 class="dropdown-header dropdown-close" @click="closeSearch">
        <i class="fa fa-close"></i>  Close
      </h6>
    </div>

  </div>
</template>

<script>
import Devices from 'services/devices'
import Files from 'services/files'
import SearchMixin from 'mixins/search'

export default {
  name: 'search',
  mixins: [SearchMixin],
  data () {
    return {
      devices: [],
      files: [],
      searchTerm: null,
      searchPendingRequests: [],
      searchResultslimit: 3
    }
  },
  methods: {
    search () {
      this.clearResults()
      this.abortPendingRequests()

      if (this.ignoreTerm()) {
        return
      }

      this.adapterSearch('devices', Devices)
      this.adapterSearch('files', Files)
    },
    closeSearch () {
      this.searchTerm = ''
      this.devices = []
      this.files = []
    },
    clearResults () {
      this.devices = []
      this.files = []
    },
    encodeCanonicalURL (file) {
      return btoa(file.canonical_url)
    }
  },
  computed: {
    haveResults () {
      return (this.devices.length + this.files.length) > 0
    }
  }
}
</script>

<style>
.search {
  position: relative;
}

.results {
  display: inline-block;
  position: absolute;
  min-width: 100%;
}

.dropdown-close {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue